<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row>
          <el-col :span="24">
            <div class="accountlist">
              <div class="account">
                <div class="top">
                  <el-button size="mini" class="top-left" icon="el-icon-check" circle></el-button>
                  <div class="top-center">已绑定手机账号：</div>
                  <div class="top-right">{{this.mobile}}</div>
                </div>
                <div class="bottom">
                  <el-button type="text" class="password" @click="resetPass">重置密码</el-button>
                  <!-- <div class="line" ></div>
                  <el-button type="text" @click="changeTel">换绑手机号</el-button> -->
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <verification
          @dialogChanged="dialogChanged($event)"
          @onSuccess="handleSuccess($event)"
          :dialogVisible="dialogVisible" />
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import Verification from "@/components/Verification"
import {mapMutations, mapState, mapGetters} from 'vuex'
export default {
  components: {
    PageHeaderLayout,
    Verification
  },
  data() {
    return {
      mobile: '',
      // codeText:'获取验证码',
      title: '手机验证',
      dialogVisible: false,
      isTel: 0,
      formData: {
        tel: '',
        Vcode: '',
      },
      rules: {
        tel: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        Vcode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ]
      }
    };
  },
  computed: {
    ...mapGetters(['userPermissions']),
    ...mapState({
      user: (state) => state.userInfo,
    })
  },
  created() {
    this.mobile = this.user.mobile
    console.log(this.userPermissions,"userPermissions")
  },
  methods: {
    handleSuccess() {
      console.log("handleSuccess")
      this.dialogVisible = false
      this.$router.push({path: 'bindaccount/resetpwd', query: { isTel: this.isTel }})
    },
    dialogChanged(state) {
      this.formData = {}
      this.dialogVisible = state
    },
    ...mapMutations([
      'handleUserInfo'
    ]),
    //重置密码
    resetPass() {
		this.$router.push({path: 'bindaccount/resetpwd', query: { isTel: this.isTel }})
      // this.dialogVisible = true;
      // this.isTel = 0
      // console.log('this.dialogVisible', this.dialogVisible)
    },
    //跟换手机号
    changeTel() {
      this.dialogVisible = true;
      this.isTel = 1
    },
  }
};
</script>

<style lang="stylus" scoped>
#page-content .main-page-content
  padding-bottom: 120px
.accountlist
  height: 209px
  background-color: #FEFEF4
  color: rgba(16, 16, 16, 1)
  font-size: 14px
  text-align: center
  font-family: Roboto
  border: 1px solid rgba(255, 255, 255, 0)
  display: flex
  align-items: center
.account
  width: 450px
  height: 100px
  margin-left: 100px
.top
  display: flex
  flex-direction: row
  justify-content: space-around
.top-left
  width: 40px
  height: 40px
  background-color: rgba(181, 222, 112, 1)
  border-radius: 50%
  text-align: center
  color: #fff
  font-size: 22px
.top-center, .top-right
  height: 55px
  color: rgba(16, 16, 16, 1)
  font-size: 25px
  text-align: left
.top-right
  color: #e69524
.bottom
  text-align: left
  display: flex
  width: 160px
  justify-content: space-around
  margin-left: 70px
.line
  height: 20px
  margin-top: 10px
  width: 2px
  background: #ccc
</style>
